/** React Query key for a deal's escrow view */
export const escrowKey = (bidId: string) => ["escrow", bidId];

export const apiMessage = (err: unknown, fallback: string) => {
  const m = (err as { response?: { data?: { message?: string | string[] } } })?.response?.data?.message;
  return Array.isArray(m) ? m.join(". ") : m || fallback;
};
